import { requestNoLogin } from '@/services/index'
export const state = {
  isLoading: false,
  sendMailSearchBooking: {
    success: false,
    data: {},
  },
}

export const mutations = {
  SET_SEND_MAIL_SEARCH_BOOKING(state, newValue) {
    state.isLoading = false
    state.sendMailSearchBooking = newValue
  },
  SET_SEND_MAIL_SEARCH_BOOKING_INIT(state, newValue) {
    state.sendMailSearchBooking = newValue
  },
  SET_IS_LOADING(state) {
    state.isLoading = true
  },
}

export const getters = {
  sendMailBooking(state) {
    return state.sendMailSearchBooking.data
  },
  sendMailBookingSuccess(state) {
    return state.sendMailSearchBooking.success
  },
  getIsLoading(state) {
    return state.isLoading
  },
}

export const actions = {
  async sendMail({ commit }, params) {
    commit('SET_IS_LOADING')
    return requestNoLogin({
      endpoint: '/api/search/search_booking',
      payload: params,
    })
      .then((res) => {
        const result = {}
        result.success = true
        result.data = res.data
        commit('SET_SEND_MAIL_SEARCH_BOOKING', result)
        return result
      })
      .catch(() => {
        const result = {}
        result.success = false
        result.data = {}
        commit('SET_SEND_MAIL_SEARCH_BOOKING', result)
        return result
      })
  },
  async sendMailInit({ commit }) {
    const result = {}
    result.success = false
    result.data = {}
    commit('SET_SEND_MAIL_SEARCH_BOOKING_INIT', result)
  },
}
